module.exports = __webpack_public_path__ + "img/pla_ae.e41b91e0.png";